import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { btn, labelClass, inputClass, card } from "@/components/org/intake/intakeMeta";

export const SubmissionSettingsStep = ({ model, onSaved }) => {
  const { API } = useAuth();
  const [values, setValues] = useState({
    request_category: model.submission_settings?.request_category || "",
    confirmation_message: model.submission_settings?.confirmation_message || "",
    notify_team: model.submission_settings?.notify_team || "",
    duplicate_handling: model.submission_settings?.duplicate_handling || "flag",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (key, val) => setValues((prev) => ({ ...prev, [key]: val }));

  const save = async () => {
    setError("");
    setSaving(true);
    try {
      const { data } = await axios.patch(`${API}/org/intake/models/${model.model_id}/submission-settings`, values, { withCredentials: true });
      onSaved(data.model);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't save.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={card} data-testid="wizard-step-submission">
      <p className="text-sm font-bold text-slate-950 dark:text-white">Submission Settings</p>
      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">Submissions land in Front Desk for manual review — nothing here auto-qualifies a lead or creates a quote.</p>

      <div className="mt-4 space-y-3">
        <div>
          <label className={labelClass}>Request Category</label>
          <input value={values.request_category} onChange={(e) => set("request_category", e.target.value)} placeholder="e.g. HVAC Repair" data-testid="submission-field-category" className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Confirmation Message</label>
          <textarea value={values.confirmation_message} onChange={(e) => set("confirmation_message", e.target.value)} rows={2} placeholder="Thanks! We'll be in touch shortly." data-testid="submission-field-confirmation" className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Notify Team (optional)</label>
          <input value={values.notify_team} onChange={(e) => set("notify_team", e.target.value)} placeholder="e.g. Front Desk team" data-testid="submission-field-notify-team" className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Duplicate Handling</label>
          <select value={values.duplicate_handling} onChange={(e) => set("duplicate_handling", e.target.value)} data-testid="submission-field-duplicate-handling" className={`${inputClass} bg-white dark:bg-[#0B1220]`}>
            <option value="flag">Flag as potential duplicate</option>
            <option value="create_new">Always create a new submission</option>
          </select>
        </div>
      </div>

      {error && <p className="mt-3 text-xs font-semibold text-red-600 dark:text-red-400" data-testid="wizard-submission-error">{error}</p>}
      <button type="button" onClick={save} disabled={saving} data-testid="wizard-submission-save-btn" className={`${btn} mt-5`}>
        {saving && <Loader2 size={14} className="animate-spin" />} Save & Continue
      </button>
    </div>
  );
};
